export const RECAPTCHA_ACTION_LOGIN = 'login'
export const REQUEST_RESET_PASSWORD = 'requestResetPassword'
export const RESET_PASSWORD = 'resetPassword'
